import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 500.000000 500.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)">

<path d="M3665 3355 c-387 -100 -781 -283 -1020 -473 -5 -4 -26 -18 -45 -32
-47 -32 -211 -173 -286 -246 -137 -133 -248 -266 -371 -444 -56 -80 -153 -244
-153 -257 0 -10 56 -13 274 -13 l273 0 13 48 c24 87 91 256 136 342 66 128
208 339 229 340 6 0 29 -31 53 -69 l42 -68 0 -297 0 -296 165 0 165 0 0 305 0
305 53 83 c30 45 77 118 105 162 28 44 76 118 106 165 30 47 100 158 157 247
l103 162 75 35 c42 19 72 35 66 35 -5 0 -68 -15 -140 -34z m-595 -404 c0 -6
-4 -12 -9 -16 -6 -3 -19 -24 -31 -48 -12 -23 -29 -53 -39 -65 l-17 -24 -19 28
-18 28 49 43 c27 24 54 47 59 53 13 12 25 12 25 1z"/>
<path d="M651 1608 c-5 -13 -30 -83 -57 -156 -32 -89 -55 -139 -71 -151 -30
-24 -29 -39 2 -47 56 -14 128 21 80 40 -8 3 -15 15 -15 26 0 25 35 40 90 40
32 0 43 -5 57 -26 16 -25 16 -27 0 -39 -36 -26 -9 -45 63 -45 77 0 102 23 57
53 -16 10 -36 49 -61 118 -62 169 -87 209 -127 209 -5 0 -13 -10 -18 -22z m33
-130 c32 -77 31 -78 -13 -78 -30 0 -41 4 -41 15 0 17 30 95 37 95 2 0 10 -15
17 -32z"/>
<path d="M903 1620 c-13 -5 -23 -12 -23 -15 0 -3 17 -23 38 -43 65 -66 92
-121 92 -190 0 -41 -5 -63 -15 -72 -20 -16 -19 -36 1 -44 29 -11 100 -6 120 9
17 14 18 16 2 28 -9 8 -19 35 -23 69 -6 51 -4 61 27 118 18 35 48 75 65 89 49
39 40 61 -25 61 -41 0 -54 -13 -46 -44 7 -29 -22 -96 -41 -96 -6 0 -22 19 -35
41 -19 34 -21 45 -11 61 10 16 8 20 -14 28 -32 12 -82 12 -112 0z"/>
<path d="M1613 1624 c-18 -8 -16 -31 4 -42 14 -8 16 -29 16 -142 0 -113 -2
-134 -16 -142 -25 -14 -20 -37 8 -44 14 -3 69 -5 123 -2 74 3 106 8 131 23
118 69 119 260 1 329 -27 16 -56 20 -144 23 -61 1 -117 0 -123 -3z m217 -64
c33 -35 46 -94 37 -168 -6 -55 -50 -102 -95 -102 -47 0 -52 14 -52 150 0 85 4
130 12 138 22 22 68 14 98 -18z"/>
<path d="M2155 1622 c-6 -4 -17 -27 -25 -52 -36 -118 -103 -269 -121 -275 -23
-8 -25 -31 -3 -39 20 -8 68 -8 88 0 21 8 21 30 0 38 -9 3 -14 15 -12 28 6 46
140 51 151 7 3 -12 0 -30 -6 -40 -16 -27 4 -39 65 -39 79 0 102 22 55 53 -13
8 -28 30 -34 48 -37 112 -96 247 -114 262 -23 19 -29 20 -44 9z m29 -162 c22
-56 21 -60 -24 -60 -22 0 -40 4 -40 10 0 18 32 90 40 90 4 0 15 -18 24 -40z"/>
<path d="M2390 1605 c-12 -31 -13 -95 -2 -95 4 0 20 14 34 31 21 23 34 30 55
27 l28 -3 -1 -129 c0 -109 -3 -129 -17 -138 -21 -11 -22 -34 -1 -42 20 -8 98
-8 118 0 20 8 21 28 1 44 -12 10 -15 39 -15 141 l0 129 29 0 c21 0 37 -9 54
-31 14 -18 29 -29 36 -25 14 9 14 48 -1 81 l-11 25 -137 -1 c-75 -1 -142 1
-148 5 -8 4 -16 -3 -22 -19z"/>
<path d="M2883 1618 c-5 -7 -21 -49 -35 -93 -39 -121 -88 -224 -109 -230 -23
-8 -25 -31 -3 -39 25 -10 73 -7 96 5 l21 11 -23 18 c-51 38 10 82 94 66 38 -7
56 -37 36 -61 -24 -29 -4 -45 54 -45 85 0 111 20 66 51 -12 8 -42 70 -74 154
-60 153 -95 200 -123 163z m43 -192 c6 -25 5 -26 -36 -26 -46 0 -46 2 -13 80
l15 35 14 -31 c7 -17 16 -43 20 -58z"/>
<path d="M3193 1610 c-48 -21 -63 -44 -63 -94 0 -30 6 -40 38 -64 22 -15 60
-39 86 -52 76 -40 73 -100 -4 -100 -33 0 -43 6 -70 40 -38 48 -60 52 -60 10 0
-83 105 -126 209 -84 48 19 71 51 71 98 0 46 -23 71 -105 114 -57 30 -71 42
-73 64 -2 19 3 30 18 38 27 14 57 5 98 -32 18 -15 37 -26 43 -23 15 10 10 58
-9 80 -24 28 -123 30 -179 5z"/>
<path d="M3453 1623 c-28 -5 -29 -23 -3 -46 18 -15 20 -29 20 -136 0 -119 0
-119 30 -150 57 -56 182 -52 233 9 22 25 25 40 30 151 4 97 9 124 21 131 44
25 -12 57 -74 43 -35 -8 -39 -25 -9 -43 20 -13 21 -20 17 -129 -3 -106 -5
-116 -27 -134 -36 -29 -109 -21 -133 15 -4 6 -8 61 -8 122 0 87 3 114 15 124
44 37 -19 61 -112 43z"/>
<path d="M1244 1599 c-4 -8 1 -18 14 -27 21 -14 22 -22 22 -137 0 -109 -2
-124 -20 -140 -36 -33 -9 -45 100 -45 123 0 154 6 185 38 45 45 30 113 -33
139 l-36 15 27 14 c50 27 61 81 26 124 -20 24 -27 25 -149 28 -95 3 -130 0
-136 -9z m210 -45 c39 -39 3 -94 -61 -94 -36 0 -40 12 -27 79 6 27 11 31 40
31 18 0 40 -7 48 -16z m14 -160 c24 -17 29 -52 10 -76 -7 -9 -32 -19 -55 -23
-49 -8 -63 8 -63 74 l0 41 43 0 c23 0 53 -7 65 -16z"/>
<path d="M3830 1596 c0 -8 7 -21 15 -30 23 -22 22 -242 -1 -267 -9 -10 -14
-25 -11 -34 5 -12 27 -15 116 -15 60 0 121 4 135 10 43 16 66 47 66 88 0 43
-17 64 -65 82 l-30 12 27 14 c55 29 63 81 19 125 -29 29 -30 29 -150 29 -98 0
-121 -3 -121 -14z m204 -42 c39 -39 3 -94 -61 -94 -31 0 -33 2 -33 33 0 62 9
77 45 77 19 0 41 -7 49 -16z m14 -160 c26 -18 29 -56 7 -78 -9 -8 -32 -18 -52
-22 -46 -9 -63 12 -63 73 l0 43 43 0 c23 0 53 -7 65 -16z"/>
</g>
</svg>



    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
